import { IDomainCalculation } from '@web_opxp/features';
import { AxiosResponse } from 'axios';
import { EDomain } from '../base/types';

export interface IDomainProgress {
  normalizedScore: number;
  time: number;
  cycleId: number;
}

export interface IDomainsProgress {
  [domainId: number]: IDomainProgress[];
}

export interface IDomainsCalculationPayload {
  domaincalculation: IDomainCalculation[];
}

export type DomainsCalculationApiResponse = AxiosResponse<IDomainsCalculationPayload>;

export enum EStatisticsTabs {
  Comparison = 'Comparison',
  Performance = 'Performance',
}

export interface IHighscoreResponse {
  workoutId: number;
  timesTrained: number;
  highscore: number;
  highscoreTimestamp: number;
  avgAccuracy: number | null;
  latestLevel: number;
  latestTimestamp: number;
}

// information needed for each exercise on choose exercise page
export interface IExercise {
  exerciseId: string;
  siblings: number[];
  locked: boolean;
}

export interface IEvaluationPageRouteParams {
  userId?: string;
}

export interface ITrainingStatistics {
  numberWorkouts?: number;
  firstTimestamp?: number;
  lastTimestamp?: number;
  finishedSessions?: number;
}

export interface ILoadEvaluationHighscoresPayload {
  workoutIds: number[];
  userId?: number;
}

export interface ILoadEvaluationsHighscoresForSingleExercisePayload {
  workoutIds: number[];
  userId?: number;
}

export interface ILoadEvaluationProgressHistoryPayload {
  startTimestamp: number;
  endTimestamp: number;
  userId?: number;
}

export interface IUpdateEvaluationProgressPayload {
  progress: IDomainProgress[];
  domain: EDomain;
}
